// Seri Senet Oluştur penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.batchPromissoryNote';

export const batchPromissoryNoteGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Seri senet nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Aynı cariye ait taksitli senetleri tek seferde oluşturursunuz: solda bilgileri girersiniz, sağda senetlerin önizlemesini görür ve tutarları düzenlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Seri Senet Oluştur'),
    body: t(`${G}.regions.body`, 'Bilgiler ve önizleme'),
    footer: t(`${G}.regions.footer`, 'Senet Oluştur'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Seri senet ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Bir satışı veya alımı taksitlere böldüğünüzde her taksit için ayrı senet açmak yerine hepsini bir kerede üretir. Tek seferde en çok 100 senet oluşturulabilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Yön, cari ve senet bilgileri'),
      text: t(`${G}.s2.text`, 'Yön\'ü seçin: "Alacak Senedi (Müşteriden)" veya "Borç Senedi (Tedarikçiye)". Cari Hesap zorunludur; seçince Keşideci Adı cari adıyla dolar. Borçlu TC Kimlik No, Keşide Yeri, Borçlu Adresi, kefil bilgileri ve Yetkili Mahkeme isteğe bağlıdır ve tüm senetlere aynen yazılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Adet, para birimi ve toplam tutar'),
      text: t(`${G}.s3.text`, 'Senet Adedi (1–100) ve Toplam Tutar\'ı girin. Toplam, senetlere eşit dağıtılır; kuruş küsuratı son senede eklenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'TRY dışında bir para birimi seçerseniz TCMB alış kuru otomatik alınır ve TL karşılığı bu kurla hesaplanır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Vade planını kurun'),
      text: t(`${G}.s4.text`, 'İlk Vade bugünden bir ay sonrasıyla başlar; değiştirebilirsiniz. Vade Aralığı\'na sayı yazıp Gün veya Ay seçin; sonraki senetlerin vadesi bu aralıkla ilerler.'),
      tips: [
        t(`${G}.s4.tip1`, 'Ay seçildiğinde kayıtta her ay 30 gün sayılır; bu yüzden kaydedilen vadeler önizlemedeki tarihlerden birkaç gün farklı olabilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Önizlemeyi kontrol edin, tutarları düzenleyin'),
      text: t(`${G}.s5.text`, 'Sağdaki tabloda her senedin belge numarası, vadesi ve tutarı görünür. Tutarları tek tek değiştirebilirsiniz. Toplam tutmazsa Tutar Farkı uyarısı çıkar; satırdaki +/− çipine tıklayınca fark o senede eklenir veya çıkarılır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Belge numaraları önizlemedir (SN-yıl-sıra). Bu sırada başka kayıt açılırsa gerçek numaralar farklı olabilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Senetleri oluşturun'),
      text: t(`${G}.s6.text`, '"… Senet Oluştur" düğmesi; cari seçili, her senet tutarı sıfırdan büyük, toplam fark 1 kuruştan az ve ilk vade girili olunca açılır. Her senet ayrı kayıt olur ve her biri için ayrı cari hareket yazılır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Alacak senedi: senetler "Portföyde" başlar, cari alacaklandırılır (müşterinin borcu azalır).'),
        t(`${G}.s6.tip2`, 'Borç senedi: senetler "Ödenmedi" başlar, cari borçlandırılır (ona olan borcumuz azalır).'),
        t(`${G}.s6.tip3`, 'Kasa ve banka bakiyesi değişmez. Senetlerin Notlar alanına ortak bir grup kodu ([BATCH-…]) eklenir.'),
      ],
    },
  ],
});
